import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  JoinSquadMutation,
  JoinSquadMutationVariables,
} from './__generated__/useJoinSquad.graphql.ts';

const JOIN_SQUAD_MUTATION = gql`
  mutation JoinSquadMutation($input: joinSquadInput!) {
    joinSquad(input: $input) {
      currentUser {
        slug
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<JoinSquadMutation, JoinSquadMutationVariables>;

export const useJoinSquad = () => {
  const [mutate, { loading }] = useMutation(JOIN_SQUAD_MUTATION, {
    showErrorsWithSnackNotification: true,
  });

  const joinSquad = async (joinSecret: string) => {
    const result = await mutate({
      variables: { input: { joinSecret } },
    });
    return result.data;
  };

  return { joinSquad, loading };
};
